import { Tile } from "../../../common/Tile";
import { compareObjects } from "../../../utils/compareObjects";

export const CurrentFeatures = ({ data }) => {
  const filteredFeatures = data?.features.result.filter((feature) => {
    const firstPart = feature.key.split('-')[0];
    return firstPart === "F";
  });

  return !data ? (
    <div>Brak danych</div>
  ) : (
    <Tile
      data={{
        companyStatus: data.companyStatus,
        features: {
          tileHeader: "Funkcjonalności Opcjonalne - zaawansowane",
          optionalFeatures: false,
          result: filteredFeatures.sort(compareObjects),
        },
      }}
    />
  );
};
